import React, { useState } from 'react';
import { TextField } from '@cimpress/react-components';

const isError = (value: number) => (!Number.isFinite(value) ? 'error' : undefined);

interface NumberInputProps {
    value: number;
    label: string;
    onSubmit(value: number): void;
}

const numberInput: React.FC<NumberInputProps> = ({ value, label, onSubmit }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- lowercase name is intentional, kept to match the original class identifier
    const [validValue, setValidValue] = useState(value);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- lowercase name is intentional, kept to match the original class identifier
    const [currentValue, setCurrentValue] = useState(value);

    if (value !== validValue) {
        setValidValue(value);
        setCurrentValue(value);
    }

    const error = isError(currentValue);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseFloat(e.target.value);
        const newError = isError(newValue);
        setCurrentValue(newValue);
        if (!newError) {
            onSubmit(newValue);
        }
    };

    return (
        <TextField
            className='number-input'
            label={label}
            value={currentValue || (currentValue === 0 ? 0 : '')}
            required={true}
            onChange={onChange}
            status={error}
            type='number'
            onFocus={(e) => e.target.select()}
        />
    );
};

export default React.memo(numberInput);
